// extracted by mini-css-extract-plugin
module.exports = {"circle-logo":"_2OQgn","sale-logo":"_27lxZ","shake":"_1VZ-1"};